export const zjcWebUrl = 'https://card.askzeta.com';
export const cloudfrontBaseUrl = 'https://d142whjg6dsdg2.cloudfront.net';

// APY rates

export const CURRENT_APY_RATE = '0%';
export const CURRENT_VIP_APY_RATE = '1.94%';
